import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SummaryModule} from "../../../../../../core/component/summary/summary.module";
import {SummaryFieldModule} from "../../../../../../core/component/summary-field/summary-field.module";
import {DateLabelModule} from "../../../../../../core/component/date/date-label/date-label.module";
import {PaymentRequestSummaryComponent} from "./payment-request-summary.component";
import {PartnerSummaryFieldModule} from "../../../../../../partner/common/api/component/partner-summary-field/partner-summary-field.module";
import {SaleSummaryFieldModule} from "../../../../../api/component/sale-summary-field/sale-summary-field.module";
import {PriceSummaryFieldModule} from "../../../../../../common/price/api/component/price-summary-field/price-summary-field.module";
import {PriceLabelModule} from '../../../../../../common/price/api/component/price-label/price-label.module';
import {
    WorkflowTaskItemModule
} from "../../../../../../workflow/task/api/component/workflow-task-item/workflow-task-item.module";
import {
    PaymentRequestReminderItemModule
} from "../../../reminder/api/component/payment-request-reminder-item/payment-request-reminder-item.module";
import {LoadingModule} from "../../../../../../../components/common/loading/loading.module";
import {ButtonModule} from "../../../../../../core/component/button/button.module";
import {
    LovValueSummaryFieldModule
} from "../../../../../../common/lov/lov-value/api/component/lov-value-summary-field/lov-value-summary-field.module";
import {ExpandableContentModule} from "../../../../../../core/component/expandable-content/expandable-content.module";
import {
    DocumentSummaryModelFieldModule
} from "../../../../../../document/common/api/component/document-summary-field/document-summary-field.module";

@NgModule({
    imports: [
        CommonModule,
        SummaryModule,
        SummaryFieldModule,
        DateLabelModule,
        PriceSummaryFieldModule,
        PartnerSummaryFieldModule,
        SaleSummaryFieldModule,
        PriceLabelModule,
        WorkflowTaskItemModule,
        PaymentRequestReminderItemModule,
        LoadingModule,
        ButtonModule,
        LovValueSummaryFieldModule,
        ExpandableContentModule,
        DocumentSummaryModelFieldModule,
    ],
    declarations: [PaymentRequestSummaryComponent],
    exports: [
        PaymentRequestSummaryComponent
    ]
})
export class PaymentRequestSummaryModule {
}
